module.exports = __webpack_public_path__ + "fonts/DINPro-Light.7ee0d764.ttf";